import bootstrap from '../actions/bootstrap'
import { set, when } from 'cerebral/operators'
import { parallel } from 'cerebral'
import { state, props } from 'cerebral/tags'
import loadOrder from '../actions/loadOrder'
import setOrder from '../actions/setOrder'
import setLanguage from '../actions/setLanguage'
import isUserAdmin from '../actions/isUserAdmin'
import loadAttestOrders from '../actions/loadAttestOrders'
import setTitle from '../actions/setTitle'
import setFavicon from '../actions/setFavicon'
import loadDefaultFiles from 'modules/Media/chains/loadDefaultFiles'
import setBasketReceivers from '../actions/setBasketReceivers'
import onShowTerms from 'modules/Startpage/chains/onShowTerms'
import redirectToAccount from '../actions/redirectToAccount'
import setSharedUUID from '../actions/setSharedUUID'

export default [
  when(state`startPage.show`),
  {
    false: [
      set(state`app.currentView`, 'media'),
      set(state`node.showMenuToggle`, true),
      set(state`node.tree.open`, true)
    ],
    true: []
  },
  bootstrap,
  {
    loggedOut: redirectToAccount,
    loggedIn: [
      parallel([
        set(state`node.nodes`, props`nodes`),
        set(state`app.user`, props`user`),
        set(state`app.client`, props`client`),
        setTitle,
        setLanguage,
        setFavicon,
        ...loadDefaultFiles
      ]),
      when(state`app.user.group.shared`),
      {
        true: [setSharedUUID],
        false: []
      },
      parallel([
        set(state`app.loading`, false),
        set(state`basket.targets`, props`targets`),
        setBasketReceivers,
        loadOrder,
        {
          loaded: [setOrder],
          noOpenOrder: []
        },
        isUserAdmin,
        {
          true: [
            loadAttestOrders,
            {
              loaded: [
                set(state`orderHistory.attestOrders`, props`attestOrders`)
              ],
              noAttestOrders: []
            }
          ],
          false: []
        },
        when(state`app.hasAgreedOnTerms`),
        {
          true: [],
          false: [
            when(state`app.client.hasTerms`),
            {
              true: [...onShowTerms],
              false: []
            }
          ]
        }
      ])
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/App/chains/bootstrap.js